import React, { useCallback, useState } from 'react';
import { FormularioVariablesPostventaVista } from '../../vista/formularioVariablesPostventaVista';
import { BarraCambiosSinGuardarVista } from '../../../configuracionCotizadorNbs/vista/barraCambiosSinGuardarVista';
import { configuracionPostventaInicial, variablesPostventaCompletas, variablesPostventaIniciales } from '../../interfaces';
import type { IVariablesPostventa } from '../../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';
import { useNotificaciones } from '../../../../globales/contextos/notificationContext';
import { EnumTipoNotificacion } from '../../../../globales/interfaces';

/** Valores por defecto: se editan juntos y se guardan con la barra de cambios sin guardar. */
export const VariablesPostventaCV: React.FC = () => {
    const { mostrarNotificacion } = useNotificaciones();
    // TODO back: consultar la configuración activa del país.
    const [variablesOriginales, setVariablesOriginales] = useState<IVariablesPostventa>(() => variablesPostventaIniciales(configuracionPostventaInicial));
    const [variables, setVariables] = useState<IVariablesPostventa>(variablesOriginales);
    const [guardando, setGuardando] = useState(false);

    const alCambiar = useCallback((campo: keyof IVariablesPostventa, valor: number | string) => {
        setVariables(prev => ({ ...prev, [campo]: valor === '' ? '' : Number(valor) }));
    }, []);

    const alGuardar = async () => {
        if (!variablesPostventaCompletas(variables)) {
            mostrarNotificacion(EnumTipoNotificacion.Warning, 'Campos Obligatorios', 'Diligencia el factor precio y la tarifa hora hombre (mayores que cero).');
            return;
        }
        setGuardando(true);
        try {
            // TODO back: guardar las variables (crea una nueva versión de la configuración).
            setVariablesOriginales(variables);
            mostrarNotificacion(EnumTipoNotificacion.Success, 'Configuración Guardada', 'Los valores por defecto se actualizaron correctamente.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div style={{ flex: 1, paddingBottom: '20px' }}>
            <FormularioVariablesPostventaVista variables={variables} alCambiar={alCambiar} />
            <BarraCambiosSinGuardarVista
                visible={JSON.stringify(variables) !== JSON.stringify(variablesOriginales)}
                alDescartar={() => setVariables(variablesOriginales)}
                alGuardar={alGuardar}
                guardando={guardando}
            />
        </div>
    );
};
